import styled from 'styled-components';
import { Button as AntDesignButton } from 'antd';
import { AA_LINK_ON_LIGHT, AA_SURFACE } from '~/modules/Helper/contrast.helper';

/** Primário Antd default (#1890ff + branco) falha AA (~3.2:1). */
function primaryBg(theme) {
  return (theme && theme.corTema) || AA_LINK_ON_LIGHT;
}

export const Button = styled(AntDesignButton)`
  && {
    margin-left: ${({ ml }) => ml}px;
    margin-right: ${({ mr }) => mr}px;
    color: ${({ color }) => color};
    border-radius: 8px;
  }

  &&.ant-btn-circle {
    border-radius: 50% !important;
  }

  &&.ant-btn-round {
    border-radius: 999px !important;
  }

  &&.ant-btn-primary {
    color: ${AA_SURFACE};
    background-color: ${({ theme }) => primaryBg(theme)};
    border-color: ${({ theme }) => primaryBg(theme)};
  }

  &&.ant-btn-primary:hover,
  &&.ant-btn-primary:focus {
    color: ${AA_SURFACE};
    background-color: ${({ theme }) => primaryBg(theme)};
    border-color: ${({ theme }) => primaryBg(theme)};
    filter: brightness(0.92);
  }
`;
